import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from '../../../shared/services/authorization.service';
@Component({
    selector: 'app-external-login',
    templateUrl: './external-login.component.html',
    standalone: false,
})
export class ExternalLoginComponent implements OnInit {
    constructor(private authorizationService: AuthorizationService) {}
    ngOnInit(): void {
        // The opener passes the user's provider as ?idp=<scheme> so the re-auth goes
        // straight to that upstream (no chooser). Read it from the popup URL and forward it.
        const idp = new URLSearchParams(window.location.search).get('idp') || undefined;
        this.authorizationService.loginIdentityServerEsig(idp);
    }
}
